import { Box, Image } from '@chakra-ui/react'
import React from 'react'

const Footer = () => {
  return (
    <Box>
        <Image  src="https://www.linkpicture.com/q/Screenshot-102.png"/>
    </Box>
  )
}

export default Footer
